<template>
    <div class="main">
        <el-dialog
            title="查看地图定位"
            :visible.sync="openData.state"
            :close-on-click-modal="false"
            width="70%"
            class="dialog_container"
            @close="dialogVisibleClone"
        >
            <div class="dialog_content">
                <el-form
                    disabled
                    label-position="left"
                    label-width="150px"
                    ref="formData"
                    :model="formData"
                >
                    <el-form-item label="资源GIS定位：">
                        <el-row>
                            <el-col :span="4">
                                <el-form-item>
                                    <el-select
                                        v-model="formData.provinceId"
                                        placeholder="请选择省"
                                        style="width: 100%"
                                        ref="selectShengChange"
                                    >
                                        <el-option
                                            v-for="(
                                                item, index
                                            ) in provinceList"
                                            :key="index"
                                            :label="item.name"
                                            :value="item.adcode"
                                        >
                                        </el-option>
                                    </el-select>
                                </el-form-item>
                            </el-col>
                            <el-col :span="4" :offset="1">
                                <el-select
                                    v-model="formData.cityId"
                                    placeholder="请选择市"
                                    ref="selectShiChange"
                                    style="width: 100%"
                                >
                                    <el-option
                                        v-for="(item, index) in cityList"
                                        :key="index"
                                        :label="item.name"
                                        :value="item.adcode"
                                    >
                                    </el-option>
                                </el-select>
                            </el-col>
                            <el-col :span="4" :offset="1">
                                <el-select
                                    v-model="formData.zoneId"
                                    placeholder="请选择区"
                                    ref="selectQuChange"
                                    style="width: 100%"
                                >
                                    <el-option
                                        v-for="(item, index) in areaList"
                                        :key="index"
                                        :label="item.name"
                                        :value="item.adcode"
                                    >
                                    </el-option>
                                </el-select>
                            </el-col>
                            <el-col :span="4" :offset="1">
                                <el-select
                                    v-model="formData.streetId"
                                    placeholder="请选择街道"
                                    ref="selectJiedaoChange"
                                >
                                    <el-option
                                        v-for="(item, index) in streetList"
                                        :key="index"
                                        :label="item.addName"
                                        :value="item.addCode"
                                    >
                                    </el-option>
                                </el-select>
                            </el-col>
                            <el-col :span="4" :offset="1">
                                <el-select
                                    v-model="formData.shequId"
                                    placeholder="请选择社区"
                                    ref="selectShequChange"
                                >
                                    <el-option
                                        v-for="item in communityList"
                                        :key="item.id"
                                        :label="item.address"
                                        :value="item.id"
                                    >
                                    </el-option>
                                </el-select>
                            </el-col>
                        </el-row>
                        <el-input
                            v-model.trim="formData.address"
                            style="margin-top: 12px; margin-bottom: 12px"
                            placeholder="请在地图的边界内点击选择或手动输入"
                        ></el-input>
                        <div class="map_container">
                            <div
                                class="map_right"
                                id="container"
                                style="width: 100%; height: 300px"
                            ></div>
                        </div>
                    </el-form-item>
                </el-form>
            </div>
            <div slot="footer" class="dialog-footer dialog-footer-btn">
                <el-button @click="dialogVisibleClone">取 消</el-button>
            </div>
        </el-dialog>
    </div>
</template>
<script>
import baseURL from "@/api/baseURL"

export default {
    props: ["openData"],
    data() {
        return {
            baseURL: "",
            imageUrl: "",
            formData: {
                address: "",
                longitude: "",
                latitude: "",
                provinceId: "",
                cityId: "",
                zoneId: "",
                streetId: "",
                shequId: "",
            },
            orgList: [],
            provinceList: [], //省列表
            cityList: [], //市列表
            areaList: [], //区列表
            streetList: [], //街道列表
            communityList: [], //社区列表
            myMap: null,
            isMap: true,
            polygons: [],
            polygon: [],
            marker: null, //地图标记点
            recMap: null,
            recIsMap: true,
            recPolygons: [],
            recPolygon: [],
            recMarker: null, //地图标记点

            isMaps: false,
        }
    },
    created() {
        this.formData = {
            address: "",
            longitude: "",
            latitude: "",
            provinceId: "",
            cityId: "",
            zoneId: "",
            streetId: "",
            shequId: "",
        }
        setTimeout(async () => {
            await this.$nextTick(() =>
                this.loadmap().then((res) => {
                    this.dataInfos()
                })
            )
        }, 200)
    },
    methods: {
        // 详情页信息
        async dataInfos() {
            const self = this
            if (this.openData) {
                let jsonTemp = this.openData
                // console.log(JSON.stringify(jsonTemp), "数据")

                self.formData.address = jsonTemp.address
                self.formData.longitude = jsonTemp.longitude
                self.formData.latitude = jsonTemp.latitude
                self.formData.provinceId = String(jsonTemp.provinceId)
                self.formData.cityId = String(jsonTemp.cityId)
                self.formData.zoneId = String(jsonTemp.zoneId)
                self.formData.streetId = String(jsonTemp.streetId)
                self.formData.shequId = Number(jsonTemp.shequId)
                let provice = await self.getDistrict()
                self.provinceList = provice.districtList
                // console.log("省", self.provinceList)
                if (!self.formData.provinceId) return
                let city = await self.getDistrict(self.formData.provinceId)
                self.cityList = city.districtList
                // console.log("市", self.cityList)
                if (!self.formData.cityId) return
                let area = await self.getDistrict(self.formData.cityId)
                self.areaList = area.districtList
                // console.log("区", self.areaList)
                if (!self.formData.zoneId) return
                let street = await self.getStreetList(self.formData.zoneId)
                self.streetList = street
                // console.log("街道", self.streetList)
                if (!self.formData.streetId) return
                let communityList = await self.getCommityList(
                    self.formData.streetId
                )
                self.communityList = communityList
                // console.log("社区", self.communityList)
                if (self.formData.latitude && self.formData.longitude) {
                    this.potintMap()
                }
            } else {
                this.$message.error("获取位置失败")
            }
        },
        // 打点
        potintMap() {
            const self = this
            try {
                self.myMap.remove(self.marker)
            } catch (err) {
                console.log(err)
            }
            self.marker = new AMap.Marker({
                icon: "http://webapi.amap.com/theme/v1.3/markers/n/mark_b.png",
                position: [
                    Number(self.formData.longitude),
                    Number(self.formData.latitude),
                ],
            })
            self.myMap.add(self.marker)
            self.myMap.setFitView()
        },
        //获取地址
        getDistrict(name = "中国", params = null) {
            let self = this
            return new Promise((resolve, reject) => {
                var opts = {
                    subdistrict: 1, //返回下一级行政区
                    extensions: "all",
                    showbiz: false, //最后一级返回街道信息
                }
                let district = new AMap.DistrictSearch(opts)
                let geocoder = new AMap.Geocoder({
                    city: "", //城市设为北京，默认：“全国”
                    radius: 1000, //范围，默认：500
                })
                try {
                    self.myMap.remove(self.marker)
                } catch (err) {
                    console.log(err)
                }

                self.marker = new AMap.Marker()
                district.search(name, (status, result) => {
                    if (status == "complete") {
                        resolve(result.districtList[0])
                        if (this.isMap) {
                            this.isMap = false
                            return
                        }
                        let bounds = result.districtList[0].boundaries
                        self.polygon = null
                    }
                })
            }).catch((err) => {
                console.log(err)
            })
        },
        //街道地址列表
        getStreetList(val) {
            let self = this
            return new Promise((resolve, reject) => {
                self.$http
                    .request({
                        url: "/ypt/admin/addressYpe/info/findList",
                        method: "POST",
                        data: {
                            parentId: val,
                            pageNo: 1,
                            pageSize: -1,
                        },
                    })
                    .then((res) => {
                        if (res.code == 200) {
                            if (!res.content) {
                                resolve([])
                                return
                            }
                            this.streetList = res.content.list
                            resolve(res.content.list)
                        } else {
                            resolve([])
                        }
                    })
            }).catch((err) => {
                console.log(err)
            })
        },
        // 社区地址列表
        getCommityList(val) {
            let self = this
            return new Promise((resolve, reject) => {
                self.$http
                    .request({
                        url: "/ypt/admin/standardAddress/info/StandardAddressTree",
                        method: "POST",
                        data: {
                            jiedaoId: val,
                        },
                    })
                    .then((res) => {
                        if (res.code == 200) {
                            if (!res.content) {
                                resolve([])
                                return
                            }
                            resolve(res.content)
                        } else {
                            resolve([])
                        }
                    })
            }).catch((err) => {
                console.log(err)
            })
        },
        //加载地图
        loadmap() {
            let self = this
            return new Promise((resolve, reject) => {
                self.myMap = new AMap.Map("container", {
                    resizeEnable: true,
                    zoom: 18,
                })
                resolve()
            })
        },
        // 关闭人员信息
        dialogVisibleClone() {
            // this.openData.state=false;
            this.$emit("cancleService", false)
        },
    },
}
</script>
<style lang='less' scoped>
.avatar {
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    font-size: 28px;
    color: #8c939d;
    width: 200px;
    height: 200px;
    line-height: 200px;

    img {
        width: 200px;
        height: 200px;
        line-height: 200px;
        display: block;
    }
}

/deep/ .el-upload {
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    width: 200px;
    cursor: pointer;
    position: relative;
    overflow: hidden;

    .avatar-uploader .el-upload:hover {
        border-color: #409eff;
    }

    .avatar-uploader-icon {
        font-size: 28px;
        color: #8c939d;
        width: 100%;
        height: 200px;
        line-height: 200px;
        text-align: center;
    }
}

.dialog-footer-btn {
    text-align: center;
}
</style>